import { useContext, useState } from "react";

import Overlay from "../../Componentes/Overlay";
import SidebarMenu from "../../Componentes/SideMenu";
import SideMenuBtn from "../../Componentes/SideMenuBtn";
import { useModal } from "../../contexts/ModalContext";
import useApi from "../../hooks/useApi";
import { AuthContext } from "../../Auth/AuthProvider";
import { VerifyPermission } from "../../Funcoes/VerifyPermission";

const RELATORIO_ENDPOINT = "/Painel/API/FolhaPag/GerarRelatorio/";

/* Tenta extrair uma mensagem JSON de um erro que voltou como blob
   (acontece quando a requisição é responseType: 'blob' e o servidor
   responde 4xx/5xx com JSON). */
const lerMensagemDeErroBlob = async (blob) => {
    try {
        const texto = await blob.text();
        const json = JSON.parse(texto);
        return json?.message ?? null;
    } catch {
        return null;
    }
};

const SidebarFolhaPag = ({ dados = [] }) => {

    const { closeModal, openModal } = useModal();
    const api = useApi();
    const { user } = useContext(AuthContext);

    const podeGerenciarEmails = VerifyPermission(user, {
        modulo: "rh",
        submodulo: "folha-pag",
        funcao: "gerenciar-emails",
    });

    const [gerandoExcel, setGerandoExcel] = useState(false);

    const handleOpenNovoLancamento = () => {

        closeModal();
        openModal("modalNovoLancamento");

    }

    const handleOpenApontamento = () => {

        closeModal();
        openModal("modalApontamentoFolha");

    }

    const handleOpenApontamentoVA = () => {

        closeModal();
        openModal("modalApontamentoVa");

    }

    const handleOpenGerenciarEmails = () => {

        closeModal();
        openModal("modalEmailsFolha");

    }

    const handleOpenAcessosObras = () => {

        closeModal();
        openModal("modalAcessosObrasFolha");

    }

    const handleGerarRelatorio = async () => {

        if (gerandoExcel) return;

        if (!Array.isArray(dados) || dados.length === 0) {
            alert("Não há lançamentos para exportar.");
            return;
        }

        setGerandoExcel(true);

        try {

            const response = await api.post(
                RELATORIO_ENDPOINT,
                { dados },
                { responseType: "blob" }
            );

            const blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "Folha_de_Pagamento.xlsx");
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

            closeModal();

        } catch (error) {

            console.error("Erro ao gerar relatório:", error);

            let msg = "Erro ao gerar o relatório.";
            const data = error?.response?.data;
            if (data instanceof Blob) {
                const apiMsg = await lerMensagemDeErroBlob(data);
                if (apiMsg) msg = apiMsg;
            } else if (typeof data?.message === "string") {
                msg = data.message;
            }

            alert(msg);

        } finally {

            setGerandoExcel(false);

        }

    }

    return (
        <Overlay state={ true } changeContent={ closeModal } >
            <SidebarMenu>
                <SideMenuBtn
                    button="NOVO LANÇAMENTO"
                    clickFunc={ handleOpenNovoLancamento }
                />
                <SideMenuBtn
                    button="RELATÓRIO DE REFERÊNCIA"
                    clickFunc={ handleGerarRelatorio }
                    isLoading={ gerandoExcel }
                />
                <SideMenuBtn
                    button="APONTAMENTO DE FOLHA"
                    clickFunc={ handleOpenApontamento }
                />
                <SideMenuBtn
                    button="APONTAMENTO DE V.A"
                    clickFunc={ handleOpenApontamentoVA }
                />
                { podeGerenciarEmails && (
                    <SideMenuBtn
                        button="GERENCIAR E-MAILS"
                        clickFunc={ handleOpenGerenciarEmails }
                    />
                ) }
                <SideMenuBtn
                    button="ACESSOS A OBRAS"
                    clickFunc={ handleOpenAcessosObras }
                />
            </SidebarMenu>
        </Overlay>
    )
}

export default SidebarFolhaPag;
